import API from "./GlobalAPI";
import { getOnlyFoodById } from "./FoodAPI";
export async function getOrderByUser(id: string) {
  try {
    const res: any = await API.getMethod(`orders?user=${id}`);
    return res.data;
  } catch (e) {
    return null;
  }
}

export async function getOrderById(id: string) {
  try {
    const res: any = await API.getMethod(`orders/${id}`);

    // get foods from ordered food
    console.log(res.data);
    let foodsPromises = res.data.orderedfoods.map((ordered: any) => {
      return getOnlyFoodById(ordered.food).then((res) => {
        ordered.food_detail = {
          thumbnail: res.thumbnail.url,
          name: res.name,
          price: res.price,
        };
      });
    });

    const orderedfoods = await Promise.all(foodsPromises);
    console.log(orderedfoods);
    return res.data;
  } catch (e) {
    return null;
  }
}

export async function postOrderedFood(orderedFoodArr: any) {
  try {
    const res: any = await Promise.all(
      orderedFoodArr.map(async (order: any) => {
        const res = await API.postMethod(`orderedfoods`, order);
        return res;
      })
    );
    return res;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function createNewOrder(data: any) {
  try {
    const res: any = await API.postMethod(`orders`, data);
    return res;
  } catch (e) {
    console.log(e);
    return null;
  }
}
